










































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { BindItem } from '../../../agiles/common';
import Moment from 'moment';

@Component
export default class SegmentView extends Vue {
  public items: Common.Segment[] = new Array(0);
  public params: Common.SegmentQuery = new Common.SegmentQuery();
  public importQuery = new Common.SegmentImportQuery('部門');
  public exportQuery = new Common.SegmentExportQuery('部門', this.params);
  public tenantSettings: Common.TenantSettings = new Common.TenantSettings();
  public hasLicenseTrade: boolean = false;
  public afterTenantVersion0830: boolean = false;
  public masterBaseStatus = Common.MasterBaseStatus;
  @Prop() public auditNo:string;

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  // 在庫単価計算方法のアラート表示
  public priceCalculationMethodAlertValues = [Common.PricingTypes.Specific];

  public created() {
    //一覧で使われていないリストをpushする
    this.$api.formatter.pendingLists.push('taxCodeWithout','taxCodeIncluded','taxCodeNoTax');
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseTrade = this.$api.hasLicense(Common.licenseFlags.import) || this.$api.hasLicense(Common.licenseFlags.export);
    // バージョンによって表示項目を制御する
    this.afterTenantVersion0830 = this.$api.afterTenantVersion(Common.TenantVersions.Version_240830);

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('コード', 150),
      new Common.GridItemConfiguration('名称', 150),
      new Common.GridItemConfiguration('会社名称', 150),
      new Common.GridItemConfiguration('郵便番号', 150),
      new Common.GridItemConfiguration('住所1', 150),
      new Common.GridItemConfiguration('住所2', 150),
      new Common.GridItemConfiguration('住所3', 150),
      new Common.GridItemConfiguration('電話番号', 150),
      new Common.GridItemConfiguration('FAX番号', 150),      
      new Common.GridItemConfiguration('法人番号表記', 150),      
      new Common.GridItemConfiguration('署名欄表記', 150),
      new Common.GridItemConfiguration('連携コード', 150),
      new Common.GridItemConfiguration('在庫確定月', 150),            
      new Common.GridItemConfiguration('部門区分1', 150),
      new Common.GridItemConfiguration('部門区分2', 150),
      new Common.GridItemConfiguration('部門区分3', 150),
      new Common.GridItemConfiguration('部門区分4', 150),
      new Common.GridItemConfiguration('部門区分5', 150),
      new Common.GridItemConfiguration('部門区分6', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );


    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;


    this.importQuery.hasLicenseTrade = this.hasLicenseTrade;
    this.exportQuery.hasLicenseTrade = this.hasLicenseTrade;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }


  public async onCreate(obj: Common.Segment) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.manager = this.$api.auth.userId;    
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Commodity):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.Segment){
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  // 一覧でチェックされている部門
  public checkedSegments: Array<Common.Segment>= new Array(0);
  public getCheckedSegments(){
    this.checkedSegments = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedSegments.push(obj);
      }
    });
  }

  public spClosingDate:Date = null;
  public showStockPostDialog(){
    this.getCheckedSegments();
    if(this.checkedSegments.length == 0) {
      this.$api.modal.show('', '対象の部門を選択して下さい。', true, null);            
      return;
    }
    if(this.checkedSegments.length > 1){
      this.$api.modal.show('', '同時に複数部門の処理は実行できません。', true, null);
      return;
    }

    var temp = this.checkedSegments[0];
    //var temp = ((this.$refs.mainList as Components.ListView).selected as Common.Segment);

    //画面起動前チェック
    var today = new Date().getCalendarDate();
    if(temp.closingDate != null && Moment(temp.closingDate).format('YYYYMM') == Moment(today).format('YYYYMM')){
      this.$api.modal.show('', '当月の確定処理は実行できません。', true, null);
      return;
    }

    if(temp.closingDate == null) 
    {
      this.spClosingDate = today;
      this.spClosingDate.setDate(1);
      this.spClosingDate.setMonth(this.spClosingDate.getMonth() -1);
    }
    else
    {
      this.spClosingDate = new Date(temp.closingDate);
      this.spClosingDate.setDate(1);
      this.spClosingDate.setMonth(this.spClosingDate.getMonth() +1);
    }

     (this.$refs.stockPostDialog as Components.ListDialog).showDialog();
  }

  public async submitStockPost(){
    //実行前チェック
    var temp = this.checkedSegments[0];
    if(temp.closingDate != null && new Date(temp.closingDate) >= this.spClosingDate){
      return this.$api.modal.showDialog('', '在庫確定を実施済みの月のため、確定が実行できませんでした。').then(()=>false);
    }

    var today = new Date().getCalendarDate();
    today.setDate(1);
    if(today <= this.spClosingDate){
      return this.$api.modal.showDialog('', '当月の確定処理は実行できません。').then(()=>false);
    }

    var query = new Common.StockPostQuery();
    query.closingDate = this.spClosingDate;
    query.segment = temp;
    return this.$api.execute(query).then(res=>{
      this.$api.modal.show('処理結果','確定処理を開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
      return true;
    }).catch(()=>{return false;});

  }

  public supClosingDate:Date = null;
  public showStockUnPostDialog(){
    this.getCheckedSegments();
    if(this.checkedSegments.length == 0) {
      this.$api.modal.show('', '対象の部門を選択して下さい。', true, null);         
      return;
    }
    if(this.checkedSegments.length > 1){
      this.$api.modal.show('', '同時に複数部門の処理は実行できません。', true, null);
      return;
    }

    var temp = this.checkedSegments[0];
    //var temp = ((this.$refs.mainList as Components.ListView).selected as Common.Segment);

    //画面起動前チェック
    if(temp.closingDate == null){
      this.$api.modal.show('', '在庫確定が未実施のため、確定取消は実行できません。', true, null);
      return;
    }
    var moment = Moment(temp.closingDate).endOf('month');
    this.supClosingDate = moment.toDate();
     (this.$refs.stockUnPostDialog as Components.ListDialog).showDialog();
  }

  public async submitStockUnPost(){
    //実行前チェック
    var temp = this.checkedSegments[0];
    var moment = Moment(this.supClosingDate).startOf('month');
    if(new Date(temp.closingDate) <= moment.toDate()){
      return this.$api.modal.showDialog('', '在庫確定が未実施の月のため、確定取消が実行できませんでした。').then(()=>false);
    }

    var query = new Common.StockUnPostQuery();
    query.closingDate = this.supClosingDate;
    query.segment = temp;
    return this.$api.execute(query).then(res =>{
      this.$api.modal.show('処理結果','確定取消処理を開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
      return true;
    }).catch(()=>{return false;});;


  }
  public replacementSegment: Common.Segment = null;
  public deleteSegment: Common.Segment = null;
  public showDeleteSegmentDialog(){
    //実行前チェック
    this.getCheckedSegments();
    if(this.checkedSegments.length == 0) {
      this.$api.modal.show('', '対象の部門を選択して下さい。', true, null);         
      return;
    }
    if(this.checkedSegments.length > 1){
      this.$api.modal.show('', '同時に複数部門の処理は実行できません。', true, null);
      return;
    }
    this.replacementSegment = null; // 付替え先を初期化
    // this.deleteSegment = this.checkedSegments[0];   // 削除対象部門
    // (this.$refs.deleteSegmentDialog as Components.ListDialog).showDialog();

    return this.$api.modal.showDialog('確認','部門に関連する取引データ、在庫データ、入出金データが全て削除されます。\r\n削除したデータは復元出来ません。\r\n削除してよろしいですか？',false).then(()=>{
      var query = new Common.DeleteSegmentQuery();
      query.segment =  this.checkedSegments[0];
      // query.replacementSegment = this.replacementSegment;
      return this.$api.execute(query).then(res =>{
        this.$api.modal.show('処理結果','削除処理を開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
        return true;
      }).catch(()=>{return false;});;
    });

  }
  // 部門データ削除ではなく取引データ削除にするため付替え部門の選択を廃止
  // public deleteSegmentData(){
  //   if(this.deleteSegment.id == this.replacementSegment.id) {
  //     return this.$api.modal.showDialog('', '付替え部門は削除対象と別の部門を選択して下さい。').then(()=>false);
  //   }
  //   return this.$api.modal.showDialog('確認','指定した部門、及び部門に関連する取引データ、在庫データ、入出金データが全て削除されます。\r\n削除したデータは復元出来ません。\r\n削除してよろしいですか？',false).then(()=>{
  //     var query = new Common.DeleteSegmentQuery();
  //     query.segment = this.deleteSegment;
  //     query.replacementSegment = this.replacementSegment;
  //     return this.$api.execute(query).then(res =>{
  //       this.$api.modal.show('処理結果','削除処理を開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
  //       return true;
  //     }).catch(()=>{return false;});;
  //   });
  // }

  showUpload: boolean = false;
  imageSourceFlag: Common.ImageSourceFlags = Common.ImageSourceFlags.None;
  uploadFileValidation: string = null;

  public onUploadFile() {
    this.showUpload = true;
    this.imageSourceFlag = Common.ImageSourceFlags.CompanyLogo;
  }
  public onUploadStampFile() {
    this.showUpload = true;
    this.imageSourceFlag = Common.ImageSourceFlags.CompanyStamp;
  }

  public onAdd(args: any) {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.uploadFileValidation = 'ファイルを選択してください。';
      args.preventDefault();
      return;
    } else if (obj[0].name.length > 50) {
      this.uploadFileValidation = '登録可能なファイル名は最大50桁です。';
      args.preventDefault();
      return;
    } else {
      this.uploadFileValidation = null;
    }
    if (obj.length == 0) return;
    const query = new Common.CompanyFileUploadQuery();
    const item = (this.$refs.mainList as Components.ListView).selected as Common.Segment;
    query.parentKey = item.auditName;
    query.parentId = item.auditNo;
    // query.description = this.description;
    query.tag = this.imageSourceFlag==Common.ImageSourceFlags.CompanyLogo ? "会社ロゴ" :
      this.imageSourceFlag==Common.ImageSourceFlags.CompanyStamp ? "会社印" : "";
    query.uploadPIC =  this.$api.auth.userId;
    query.segment = item;
    query.imageSourceFlag = this.imageSourceFlag;
    for (var i = 0; i < obj.length; i++) {
      let file = obj[i];
      query.timestamps += new Date(file.lastModified).toISOString() + ',';
    }
    this.$api.upload(query, obj).then(response => {
      (this.$refs.mainList as Components.ListView).reload();
    });
  }
  
  public onInput() {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) {
      this.uploadFileValidation = 'ファイルを選択してください。';
    } else if (obj[0].name.length > 50) {
      this.uploadFileValidation = '登録可能なファイル名は最大50桁です。';
    } else {
      this.uploadFileValidation = null;
    }
  }
  public onDownload(fileId: number) {
    const query = new Common.CompanyFileDownloadQuery();
    query.fileId = fileId;
    this.$api.download(query);
  }
  public logoFileDelete(fileId: number){
    this.onDelete(fileId,Common.ImageSourceFlags.CompanyLogo);
    }
  public stampFileDelete(fileId: number){
    this.onDelete(fileId,Common.ImageSourceFlags.CompanyStamp);
    }
  public onDelete(fileId: number, imageSourceFlag: Common.ImageSourceFlags){
    const item = (this.$refs.mainList as Components.ListView).selected as Common.Segment;
    if(item.fileId == null && imageSourceFlag == Common.ImageSourceFlags.CompanyLogo) return;
    if(item.stampFileId == null && imageSourceFlag == Common.ImageSourceFlags.CompanyStamp) return;
    const query = new Common.CompanyFileDeleteQuery();
    query.segment = item;
    query.imageSourceFlag = imageSourceFlag;
    this.$api.execute(query).then(res => {
      (this.$refs.mainList as Components.ListView).reload();
    });
  }
}
